const VERIFIER_LENGTH = 64;
const VERIFIER_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';

export function generateCodeVerifier() {
  const bytes = new Uint8Array(VERIFIER_LENGTH);
  crypto.getRandomValues(bytes);
  let out = '';
  for (let i = 0; i < VERIFIER_LENGTH; i++) {
    out += VERIFIER_CHARS[bytes[i] % VERIFIER_CHARS.length];
  }
  return out;
}

function base64UrlEncode(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export async function computeCodeChallengeS256(verifier) {
  const data = new TextEncoder().encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(digest);
}

export function generateOAuthState() {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return base64UrlEncode(bytes);
}

export function buildAuthorizeUrl({
  authUrl,
  clientId,
  redirectUri,
  scope,
  state,
  codeChallenge,
  prompt,
}) {
  const url = new URL(authUrl);
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('client_id', clientId);
  url.searchParams.set('redirect_uri', redirectUri);
  url.searchParams.set('code_challenge', codeChallenge);
  url.searchParams.set('code_challenge_method', 'S256');
  if (state) url.searchParams.set('state', state);
  if (scope) url.searchParams.set('scope', scope);
  // `prompt=login` makes the IdP drop its browser session and show the login
  // form instead of completing silently against whoever is already signed in
  // there (apiboo-auth authorize_controller.ex `prompt_redirection/1`, which
  // logs the session out keeping `return_to`, so the flow resumes afterwards).
  if (prompt) url.searchParams.set('prompt', prompt);
  return url.toString();
}

export function parseCallbackUrl(callbackUrl) {
  const url = new URL(callbackUrl);
  const error = url.searchParams.get('error');
  if (error) {
    const desc = url.searchParams.get('error_description') || error;
    throw new Error(desc);
  }
  const code = url.searchParams.get('code');
  const state = url.searchParams.get('state');
  if (!code) throw new Error('Authorization code missing from callback');
  return { code, state };
}

export function defaultRedirectUri(port) {
  return `http://127.0.0.1:${port}/callback`;
}

export function expiresAtFromExpiresIn(expiresInSeconds) {
  if (!expiresInSeconds || Number.isNaN(Number(expiresInSeconds))) return null;
  return Date.now() + Number(expiresInSeconds) * 1000;
}
